"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pub-container home"
  }, [_c("div", {
    staticStyle: {
      margin: "20px 0"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _c("el-form", {
    ref: "form",
    staticStyle: {
      width: "100%",
      "padding-right": "20px"
    },
    attrs: {
      model: _vm.formData,
      "label-width": "100px",
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "权益人",
      prop: "beneficiaryName"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入权益人姓名"
    },
    on: {
      blur: _vm.onSubmit
    },
    model: {
      value: _vm.formData.beneficiaryName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "beneficiaryName", $$v);
      },
      expression: "formData.beneficiaryName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "证件类型",
      prop: "idType"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "证件类型"
    },
    on: {
      change: _vm.onSubmit
    },
    model: {
      value: _vm.formData.idType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "idType", $$v);
      },
      expression: "formData.idType"
    }
  }, _vm._l(_vm.SdcIdTypeEnum, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "证件号",
      prop: "idNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入权益人证件号"
    },
    on: {
      blur: _vm.onSubmit
    },
    model: {
      value: _vm.formData.idNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "idNumber", $$v);
      },
      expression: "formData.idNumber"
    }
  })], 1)], 1), _c("el-divider"), _vm._t("default")], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;